<template>
  <div>
    <el-table
    :data="tableData"
    stripe
    :height="tabH">
      <el-table-column
        v-for="col in cols"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        key="edit"
        label="修改"
        width="80">
        <template v-if="col.prop == 'edit'" scope="scope">
          <el-button size="small" @click="edit(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import solutionDlg from '@/components/solutionDlg'

  export default {
    data () {
      return {
        cols: [
          {
            prop: 'guid',
            label: 'guid',
            width: 150
          },
          {
            prop: 'pguid',
            label: '题目id',
            width: 80
          },
          {
            prop: 'title',
            label: '标题',
            width: 80
          },
          {
            prop: 'content',
            label: '内容',
            width: 80
          },
          {
            prop: 'author2Guid',
            label: '原作者Guid',
            width: 100
          },
          {
            prop: 'date',
            label: '日期',
            width: 100
          },
          {
            prop: 'up',
            label: '赞数',
            width: 150
          },
          {
            prop: 'favorite',
            label: '收藏数',
            width: 120
          },
          {
            prop: 'discuss',
            label: '讨论数',
            width: 150
          }
        ]
      }
    },
    props: ['tableData'],
    computed: {
      tabH () {
        return this.winH - (this.search ? this.search.getHeight() : 80) - 88
      }
    },
    methods: {
      edit (guid) {
        console.log('solutionDlg->edit guid = ', guid)
        solutionDlg({
          isEditData: true,
          guid: guid
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// solutionTable.vue?7af4cbfc